export const GetLMMainNavigation = async () => {
  let response: any = {};

  await fetch('/api/sitecore/NowNavigationAsync/GetLMMainNavigation', {
    method: 'POST',
  })
    .then((res) => res.json())
    .then(
      (res) => {
        try {
          response = JSON.parse(JSON.stringify(res));
        } catch (err: any) {
          console.error(`${'GetLMMainNavigation'}() >> ${err.message}`);
        }
      },
      (error) => {
        console.error(`${'GetLMMainNavigation'}() >> ${error}`);
      },
    );

  return response;
};

interface IMySettingsServer {
  links: ILinkDivderViewModel[];
}
export async function GetMySettings(): Promise<ILinkDivderViewModel[]> {
  try {
    const res = await fetch('/api/sitecore/NowNavigationAsync/GetMySettings', { method: 'GET' });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: IMySettingsServer = await res.json();
        return data.links;
      } else {
        console.error(`${'GetMySettings'}() >> ${res.text()}`);
      }
    }
  } catch (ex) {
    console.error(`${'GetMySettings'}() >> ${ex}`);
  }
  return [];
}
